module.exports = __webpack_public_path__ + "static/media/4.f314f8a1.png";